 // Create a new file `FarmSelector.js` in the same directory as `filters.js` and add the following code:

import { createFilterOptions } from "@mui/material";
import React from "react";
import { FormControl, InputLabel, Autocomplete, TextField, Chip, Box, styled, darken, lighten } from "@mui/material";

 const FarmSelector = ({ farms, strategicAccounts, selectedFarms, setSelectedFarms, multiFarmSelect, disabled }) => {
    const GroupHeader = styled('div')(({ theme }) => ({
        position: 'sticky',
        top: '-8px',
        padding: '4px 10px',
        color: theme.palette.primary.main,
        backgroundColor: lighten(theme.palette.primary.light, 0.85),
        ...theme.applyStyles('dark', {
            backgroundColor: darken(theme.palette.primary.main, 0.8),
        }),
    }));

    const GroupItems = styled('ul')({
        padding: 0,
    });

    const filterOptions = createFilterOptions({
        matchFrom: 'any',
        stringify: (option) => option?.name + option?.parent_strategic_acct?.name + option?.parent_sub_entity_acct1?.name + option?.parent_sub__sub_entity_acct2?.name,
        trim: true
    });

    // console.log('farms', farms)
    return (
        <FormControl key={'farmSelector'} sx={{ minWidth: '230px', maxWidth: '30%' }} variant="outlined">
            {farms?.length > 1 &&
                <>
                    <InputLabel style={{ zIndex: 101, backgroundColor: "#fff", paddingRight: 5, paddingLeft: 5, marginLeft: -5 }} shrink={true} variant="outlined" id="acct-labe2">Entity</InputLabel>

                    <Autocomplete
                        key={option => option.id}
                        value={selectedFarms}
                        options={farms}
                        isOptionEqualToValue={(option, value) => { return option?.id === value?.id }}
                        groupBy={(farm) => farm.parent_strategic_acct.id}
                        getOptionLabel={(option) => {
                            return `${option?.parent_sub_entity_acct1 ? `${option?.parent_sub_entity_acct1?.name}/` : ""} ${option?.parent_sub_sub_entity_acct2 ? `${option?.parent_sub_sub_entity_acct2?.name}/` : ""}${option?.name}`
                        }}
                        disabled={disabled}
                        autoSelect
                        filterOptions={filterOptions}
                        noOptionsText={"No Matching Entity"}
                        multiple={multiFarmSelect}
                        limitTags={3}
                        onChange={(_, selectedFarms) => {
                            setSelectedFarms(selectedFarms);
                        }}
                        renderInput={(params) => <TextField sx={{ zIndex: 100, background: 'white', '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(0, 0, 0, 0.87)', borderWidth: 1 } }} {...params} label="All" />}
                        disablePortal
                        renderGroup={(params) => (
                            <li key={params.key}>
                                <GroupHeader>
                                    <Box sx={{ display: 'flex', p: 1, borderRadius: 1 }}>
                                        <Box sx={{ flexGrow: 1 }}>
                                            {strategicAccounts?.filter(s => s.id === params.group)[0]?.name}
                                        </Box>

                                        {multiFarmSelect && 
                                             <Box
                                             style={{ cursor: 'pointer' }}
                                             onClick={(e) => {
                                                 e.preventDefault();
                                                 setSelectedFarms([...selectedFarms || [], ...farms?.filter(f => f.parent_strategic_acct.id === params.group)]);
                                             }}
                                         >
                                             All
                                         </Box>
                                        
                                        }
                                   
                                    </Box>
                                </GroupHeader>
                                <GroupItems>
                                    {params.children}
                                </GroupItems>
                            </li>
                        )}
                    />
                </>
            }
        </FormControl>
    );
};

export default FarmSelector;